export default __webpack_public_path__ + "static/media/638.c634e4fe.png";